<template>
    <div class="row">
        <div class="col-md-3">
            <div class="info-box mb-3">
                <span class="info-box-icon bg-danger elevation-1"
                    ><i class="fas fa-vials"></i
                ></span>

                <div class="info-box-content">
                    <span class="info-box-text">Reactive</span>
                    <span class="info-box-number">{{ totalReactive }}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
        </div>
        <div class="col-md-3 offset-md-6">
            <div class="text-right">
                <select
                    v-model="year"
                    class="form-control"
                    @change="genderCounters"
                >
                    <option v-for="(single, index) in years" :key="index">{{
                        single
                    }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12">
            <div class="card">
                <div id="chartdivGender"></div>
            </div>
        </div>
    </div>
</template>

<script>
// importing AMCharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
//default theme for AMcharts
am4core.useTheme(am4themes_animated);

export default {
    name: "city-wise-gender",
    data() {
        return {
            registration: null,
            year: 2021,
            totalReactive: null,
            years: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021]
        };
    },
    methods: {
        genderCounters() {
            axios
                .post("cityWiseGender", { year: this.year })
                .then(response => {
                    console.log(response.data);
                    this.totalReactive = response.data[1];
                    this.populateCityWise(response.data[0]);
                })
                .catch(error => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        },
        populateCityWise(data) {
            am4core.ready(function() {
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                var chart = am4core.create("chartdivGender", am4charts.XYChart);

                // Add data
                chart.data = data;

                // Create axes
                var categoryAxis = chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );
                categoryAxis.dataFields.category = "CityName";
                categoryAxis.title.text = "Local country offices";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 20;
                categoryAxis.renderer.cellStartLocation = 0.1;
                categoryAxis.renderer.cellEndLocation = 0.9;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.title.text = "Expenditure (M)";

                // Create series
                function createSeries(field, name, stacked) {
                    var series = chart.series.push(
                        new am4charts.ColumnSeries()
                    );
                    series.dataFields.valueY = field;
                    series.dataFields.categoryX = "CityName";
                    series.name = name;
                    series.columns.template.tooltipText =
                        "{name}: [bold]{valueY}[/]";
                    series.stacked = stacked;
                    series.columns.template.width = am4core.percent(95);
                }

                createSeries("gender", "Gender", true);

                // Add legend
                chart.legend = new am4charts.Legend();
            });
        }
    },
    mounted() {
        // this.genderCounters();
    }
};
</script>

<style lang="scss" scoped>
#chartdivGender {
    width: 100%;
    height: 500px;
}
</style>
